const listaDeFilasTarefas = (state) => {
    return state.items;
}

const listaDeWorkflowsPorTarefa = (state) => {
    return state.itemsWorkflows;
}

const listaDePcoTarefas = (state) => {
    return state.itemsPcoTarefas;
}

const loadingPcoTarefas = (state) => {
    return state.carregando
}

const listagemDeTarefaDados = (state) => {
    return state.itemsPcoTarefas;
}

const tarefaSelecionada = (state) => {
    return state.tarefaSelecionada
}

const totalizadoresFilasTarefa = (state) => {
    return state.totais;
}

export {
    listaDeFilasTarefas,
    listaDeWorkflowsPorTarefa,
    listaDePcoTarefas,
    loadingPcoTarefas,
    listagemDeTarefaDados,
    tarefaSelecionada,
    totalizadoresFilasTarefa
}